import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <Link to="/" className="footer-brand-name">
            OneRoof Beauty
          </Link>
          <p>Beautiful braids, thoughtfully styled.</p>
        </div>

        <nav className="footer-links" aria-label="Legal and site links">
          <Link to="/booking-agreement">Booking Agreement</Link>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>

      <div className="site-footer-bottom">
        <span>
          © {new Date().getFullYear()} OneRoof Beauty
        </span>
        <span>All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;